module.exports = __webpack_public_path__ + "img/FCanErdogan.76a4ba27.png";